import { UserPermission, UserProfile } from 'constants/interface';
import { requestClient } from 'infra/request';

export interface AuthenticationApi {
  authenticate(
    email: string,
    password: string,
  ): Promise<UserProfile & { permissions: UserPermission[] }>
  logout(): Promise<void>
  refreshData(): Promise<UserProfile & { permissions: UserPermission[] }>
}

const authenticationApiBuilder = (): AuthenticationApi => {
  const authenticate = async (email: string, password: string) => {
    const result = await requestClient.post('/login', {
      email,
      password,
    });

    const userData: UserProfile & { permissions: UserPermission[] } = result.data;
    return userData;
  };

  const logout = async () => { await requestClient.post('/logout'); };

  const refreshData = async () => {
    const result = await requestClient.get('/users/me');
    const userData: UserProfile & { permissions: UserPermission[] } = result.data;
    return userData;
  };

  return {
    authenticate,
    logout,
    refreshData,
  };
};

export const authenticationApi = authenticationApiBuilder();
